import {
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { api } from "./api";

export interface WhitelistEntry {
  email: string;
  source: "env" | "db";
  addedBy: string | null;
  addedAt: string | null;
}

const KEY = ["admin", "settings", "whitelist"] as const;

export function useWhitelist() {
  return useQuery<{ items: WhitelistEntry[] }>({
    queryKey: KEY,
    queryFn: () => api("/admin/settings/whitelist"),
    staleTime: 30_000,
  });
}

export function useAddWhitelist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (email: string) =>
      api<{ ok: true; email: string }>("/admin/settings/whitelist", {
        method: "POST",
        body: JSON.stringify({ email }),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useRemoveWhitelist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (email: string) =>
      api<{ ok: true }>(
        `/admin/settings/whitelist/${encodeURIComponent(email)}`,
        { method: "DELETE" },
      ),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
